import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

const ShortStraddleSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
    <path d="M1.26667 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
    <path d="M1.2464 18.0225H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
    <path d="M1 29.8642L5.23253 23.1943L8.5 18" stroke="#A40C0C" strokeWidth="2"/>
    <path d="M32.5 30L27.5 23C27.5 23 25.3897 19.9473 24 18" stroke="#A40C0C" strokeWidth="2"/>
    <path d="M24 18L16 6.5L8.5 18" stroke="#089981" strokeWidth="2"/>
</svg>)
const ShortStraddle: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {ShortStraddleSvg(props)}
    </SvgIcon>
));
export default ShortStraddle
